export default {
    loading: 'Loading...',
    and: ' and ',
    authenticating: 'Authenticating...',
    exiting: 'Exiting...',

    accept: 'Accept',
    cancel: 'Cancel',
    reset: 'Reset',
    mock: 'Demo',
    apply: 'Apply',
}
